import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d166e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-12 items-stretch" }
const _hoisted_2 = { class: "flex items-center justify-between mt-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Workspace Settings ")
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, "Profile", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, "Team", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Name:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Icon:", -1))
const _hoisted_9 = {
  style: { width: '40px', height: '40px' },
  class: "text-h1 flex items-center justify-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Danger Zone:", -1))
const _hoisted_12 = {
  key: 0,
  class: "border-b border-charcoal-ghost mention"
}
const _hoisted_13 = {
  key: 1,
  class: "flex gap-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Icon, {
        icon: ['fal', 'times'],
        class: "icon-base p-mention clickable",
        onClick: _ctx.closeHelper
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "settings-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openProfileHelper && _ctx.openProfileHelper(...args)))
      }, [
        _createVNode(_component_Icon, {
          icon: ['fal', 'user'],
          class: "icon-base"
        }),
        _hoisted_5,
        _createVNode(_component_Icon, {
          icon: ['fal', 'caret-right'],
          class: "icon-base link-caret"
        })
      ]),
      _createElementVNode("div", {
        class: "settings-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTeamHelper && _ctx.openTeamHelper(...args)))
      }, [
        _createVNode(_component_Icon, {
          icon: ['fal', 'users'],
          class: "icon-base"
        }),
        _hoisted_6,
        _createVNode(_component_Icon, {
          icon: ['fal', 'caret-right'],
          class: "icon-base link-caret"
        })
      ])
    ]),
    _hoisted_7,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._name) = $event)),
      class: "mention clickable rounded-mention p-cell border border-warm bg-warm hover:shadow-base-inset",
      placeholder: "name",
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveName && _ctx.saveName(...args)))
    }, null, 544), [
      [_vModelText, _ctx._name]
    ]),
    _hoisted_8,
    _createElementVNode("div", {
      class: "clickable rounded-mention p-12 border border-warm bg-warm hover:shadow-base-inset self-start",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectIcon && _ctx.selectIcon(...args)))
    }, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx._icon), 1)
    ]),
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("div", {
      class: "p-cell btn-danger-outline rounded-mention",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.warning = true))
    }, " Delete Workspace "),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Are you sure? "))
      : _createCommentVNode("", true),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "p-cell btn-fine-outline rounded-mention flex-1 font-semibold",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.warning = false))
          }, " No "),
          _createElementVNode("div", {
            class: "p-cell btn-danger-outline rounded-mention flex-1 font-semibold",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteWorkspace && _ctx.deleteWorkspace(...args)))
          }, " Yes, Delete ")
        ]))
      : _createCommentVNode("", true)
  ]))
}